import React, { useEffect, useState } from "react";
import "./License.css";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import Camera from "../../assets/svg/Camera.svg";
import AddPhoto from "../../assets/svg/AddPhoto.svg";
import MenuItem from "@mui/material/MenuItem";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { TextField } from "@mui/material";
import { Plus } from "lucide-react";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { Edit } from "@mui/icons-material";
import NotFound from "../SharedModule/NotFound";

const License = () => {
  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  const { id } = useParams();

  //  ******************************* license section *********************************

  // ********* license modal *********

  const licenseStatuses = [
    { name: "Pending", value: "pending" },
    { name: "Valid", value: "valid" },
    { name: "Expired", value: "expired" },
    { name: "Suspended", value: "suspended" },
    { name: "Revoked", value: "revoked" },
  ];

  const [addLicense, setAddLicense] = useState({
    license_number: "",
    license_type_id: "",
    status: "",
    renewal_date: "",
    expired_date: "",
    license_photo: "",
  });

  const [showLicense, setShowLicense] = useState(false);

  const handleShowLicense = () => {
    setAddLicense({
      license_number: "",
      license_type_id: "",
      status: "",
      renewal_date: "",
      expired_date: "",
      license_photo: "",
    });
    setIsEditing(false);
    setEditLicenseId(null);
    setShowLicense(true);
  };

  const handleCloseLicense = () => {
    setShowLicense(false);
    setIsEditing(false);
    setEditLicenseId(null);
  };

  const onSubmitAddLicense = () => {
    const headers = {
      Authorization: "Bearer " + token,
    };

    const formData = new FormData();

    if (isEditing) {
      formData.append("_method", "PATCH");
    }

    if (addLicense.license_photo instanceof File) {
      formData.append("license_photo", addLicense.license_photo);
    } else {
      toast.error("Please upload a valid image for the license.");
      return;
    }

    formData.append("license_type_id", addLicense.license_type_id);
    formData.append("license_number", addLicense.license_number);
    formData.append("status", addLicense.status);
    formData.append("renewal_date", addLicense.renewal_date);
    formData.append("expired_date", addLicense.expired_date);

    const url = isEditing
      ? `${newBaseUrl}/api/portal/vehicles/${id}/driver-licenses/${editLicenseId}`
      : `${newBaseUrl}/api/portal/vehicles/${id}/driver-licenses`;

    axios
      .post(url, formData, { headers })
      .then((response) => {
        console.log(response.data);
        toast.success(
          isEditing
            ? "License Updated Successfully"
            : "License Added Successfully",
          { autoClose: 3000 }
        );
        setShowLicense(false);
        setIsEditing(false);
        getLicenseData();
        setAddLicense({
          license_number: "",
          license_type_id: "",
          status: "",
          renewal_date: "",
          expired_date: "",
          license_photo: "",
        });
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  };

  // edit license

  const [isEditing, setIsEditing] = useState(false);

  const [editLicenseId, setEditLicenseId] = useState(null);

  const handleEditLicense = (license) => {
    console.log(license);

    const fullImageUrl = license?.license_photo_path?.startsWith("http")
      ? license.license_photo_path
      : license?.license_photo_path
      ? `${newBaseUrl}${license.license_photo_path}`
      : "path/to/default-image.jpg";

    setAddLicense({
      license_number: license.license_number,
      license_type_id: license.type?.id,
      status: license.status,
      renewal_date: license.renewal_date,
      expired_date: license.expired_date,
      license_photo: "",
      fileUrl: fullImageUrl,
    });
    setValue("license_number", license.license_number);
    setValue("license_type_id", license.type?.id);
    setValue("status", license.status);
    setValue("renewal_date", license.renewal_date);
    setValue("expired_date", license.expired_date);
    setIsEditing(true);
    setEditLicenseId(license.id);
    setShowLicense(true);
  };

  // ********** license data **********

  const [licenseData, setLicenseData] = useState([]);

  const getLicenseData = async () => {
    try {
      const response = await axios.get(
        `${newBaseUrl}/api/portal/vehicles/${id}/driver-licenses`,
        { headers }
      );
      console.log("licenses", response.data.data.licenses);
      setLicenseData(response.data.data.licenses);
    } catch (error) {
      console.log("error licines", error);
    }
  };

  // ********** license types **********

  const [licenseTypes, setLicenseTypes] = useState([]);

  const getLicenseTypes = async () => {
    try {
      const response = await axios.get(`${newBaseUrl}/api/license_types`, {
        headers,
      });
      console.log("licines types", response.data.data.license_types);
      setLicenseTypes(response.data.data.license_types);
    } catch (error) {
      console.log("error licines", error);
    }
  };

  // ******************************* insurance section *******************************

  // *********- insurance modal *********

  const [addInsurance, setAddInsurance] = useState({
    type_id: "",
    provider: "",
    amount: "",
    policy_number: "",
    expiry_date: "",
  });

  const [showInsurance, setShowInsurance] = useState(false);

  const handleShowInsurance = () => {
    setAddInsurance({
      type_id: "",
      provider: "",
      amount: "",
      policy_number: "",
      expiry_date: "",
    });
    setIsInsuranceEditing(false);
    setEditInsuranceId(null);
    setShowInsurance(true);
  };

  const handleCloseInsurance = () => {
    setShowInsurance(false);
    setIsInsuranceEditing(false);
    setEditInsuranceId(null);
  };

  const onSubmitAddInsurance = () => {
    const formData = new FormData();

    if (isInsuranceEditing) {
      formData.append("_method", "PATCH");
    }

    formData.append("type_id", addInsurance.type_id);
    formData.append("provider", addInsurance.provider);
    formData.append("amount", addInsurance.amount);
    formData.append("policy_number", addInsurance.policy_number);
    formData.append("expiry_date", addInsurance.expiry_date);

    const url = isInsuranceEditing
      ? `${newBaseUrl}/api/portal/vehicles/${id}/insurances/${editInsuranceId}`
      : `${newBaseUrl}/api/portal/vehicles/${id}/insurances`;

    axios
      .post(url, formData, { headers })
      .then((response) => {
        console.log(response.data);
        toast.success(
          isInsuranceEditing
            ? "Insurance Updated Successfully"
            : "Insurance Added Successfully",
          { autoClose: 3000 }
        );
        setShowInsurance(false);
        setIsInsuranceEditing(false);
        getInsuranceData();
        setAddInsurance({
          type_id: "",
          provider: "",
          amount: "",
          policy_number: "",
          expiry_date: "",
        });
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  };

  // edit insurance

  const [isInsuranceEditing, setIsInsuranceEditing] = useState(false);

  const [editInsuranceId, setEditInsuranceId] = useState(null);

  const handleEditInsurance = (insurance) => {
    console.log(insurance);

    setAddInsurance({
      type_id: insurance.type.id,
      provider: insurance.provider,
      amount: insurance.amount,
      policy_number: insurance.policy_number,
      expiry_date: insurance.expiry_date,
    });
    setValue("type_id", insurance.type.id);
    setValue("provider", insurance.provider);
    setValue("amount", insurance.amount);
    setValue("policy_number", insurance.policy_number);
    setValue("expiry_date", insurance.expiry_date);
    setIsInsuranceEditing(true);
    setEditInsuranceId(insurance.id);
    setShowInsurance(true);
  };

  // ********** insurance data *********

  const [insuranceData, setInsuranceData] = useState([]);

  const getInsuranceData = async () => {
    try {
      const response = await axios.get(
        `${newBaseUrl}/api/portal/vehicles/${id}/insurances`,
        { headers }
      );
      console.log("insurance", response.data.data.insurances);
      setInsuranceData(response.data.data.insurances);
      // setInsuranceData(response.data.data.insurances);
    } catch (error) {
      console.log(error);
    }
  };

  // ********* insurance types *********

  const [insuranceTypes, setInsuranceTypes] = useState([]);

  const getInsuranceTypes = async () => {
    try {
      const response = await axios.get(
        `${newBaseUrl}/api/portal/insurance_types`,
        { headers }
      );
      console.log("insurance types", response.data.data.insurance_types);
      setInsuranceTypes(response.data.data.insurance_types);
    } catch (error) {
      console.log(error);
    }
  };

  // ******************************* inspection section *******************************

  // ********* inspection modal **********

  const inspectionStatuses = [
    { name: "Passed", value: "passed" },
    { name: "Failed", value: "failed" },
    { name: "Pending", value: "pending" },
  ];

  const [addInspection, setAddInspection] = useState({
    type_id: "",
    inspector_name: "",
    inspection_date: "",
    last_inspection_date: "",
    status: "",
  });

  const [showInspection, setShowInspection] = useState(false);

  const handleShowInspection = () => {
    setAddInspection({
      type_id: "",
      inspector_name: "",
      inspection_date: "",
      last_inspection_date: "",
      status: "",
    });
    setIsInspectionEditing(false);
    setEditInspectionId(null);
    setShowInspection(true);
  };

  const handleCloseInspection = () => {
    setShowInspection(false);
    setIsInspectionEditing(false);
    setEditInspectionId(null);
  };

  const onSubmitAddInspection = () => {
    const formData = new FormData();

    if (isInspectionEditing) {
      formData.append("_method", "PATCH");
    }

    formData.append("type_id", addInspection.type_id);
    formData.append("inspector_name", addInspection.inspector_name);
    formData.append("inspection_date", addInspection.inspection_date);
    formData.append("last_inspection_date", addInspection.last_inspection_date);
    formData.append("status", addInspection.status);

    const url = isInspectionEditing
      ? `${newBaseUrl}/api/portal/vehicles/${id}/inspections/${editInspectionId}`
      : `${newBaseUrl}/api/portal/vehicles/${id}/inspections`;

    //  const url = `${newBaseUrl}/api/portal/vehicles/${id}/inspections`;

    axios
      .post(url, formData, { headers })
      .then((response) => {
        console.log(response.data);
        toast.success(
          isInspectionEditing
            ? "Inspection Updated Successfully"
            : "Inspection Added Successfully",
          { autoClose: 3000 }
        );
        setShowInspection(false);
        setIsInspectionEditing(false);
        setEditInspectionId(null);
        getInspectionData();
        setAddInspection({
          type_id: "",
          inspector_name: "",
          inspection_date: "",
          last_inspection_date: "",
          status: "",
        });
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  };

  //  edit inspection

  const [isInspectionEditing, setIsInspectionEditing] = useState(false);

  const [editInspectionId, setEditInspectionId] = useState(null);

  const handleEditInspection = (inpection) => {
    console.log(inpection);
    const formatDate = (dateString) =>
      dateString ? dateString.split(" ")[0] : "";
    setAddInspection({
      type_id: inpection.type.id,
      inspector_name: inpection.inspector_name,
      inspection_date: formatDate(inpection.inspection_date),
      last_inspection_date: formatDate(inpection.last_inspection_date),
      status: inpection.status,
    });
    setValue("type_id", inpection.type.id);
    setValue("inspector_name", inpection.inspector_name);
    setValue("inspection_date", formatDate(inpection.inspection_date));
    setValue(
      "last_inspection_date",
      formatDate(inpection.last_inspection_date)
    );
    setValue("status", inpection.status);
    setIsInspectionEditing(true);
    setEditInspectionId(inpection.id);
    setShowInspection(true);
  };

  // ********* inspection data **********

  const [inspectionData, setInspectionData] = useState([]);

  const getInspectionData = async () => {
    try {
      const response = await axios.get(
        `${newBaseUrl}/api/portal/vehicles/${id}/inspections`,
        { headers }
      );
      console.log("inspection", response.data.data.inspections);
      setInspectionData(response.data.data.inspections);
      // setInspectionData(response.data.data.inspections);
    } catch (error) {
      console.log(error);
    }
  };

  // ********* inspection types *********

  const [inspectionTypes, setInspectionTypes] = useState([]);

  const getInspectionTypes = async () => {
    try {
      const response = await axios.get(
        `${newBaseUrl}/api/portal/inspection_types`,
        { headers }
      );
      console.log("inspection types", response.data.data.inspection_types);
      setInspectionTypes(response.data.data.inspection_types);
    } catch (error) {
      console.log(error);
    }
  };

  // ************************************** effects & useForm ********************************************

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm();

  useEffect(() => {
    getLicenseData();
    getInsuranceData();
    getInspectionData();
  }, [id]);

  useEffect(() => {
    getLicenseTypes();
    getInsuranceTypes();
    getInspectionTypes();
  }, [id]);

  return (
    <>
      {/* license modal */}
      <Modal show={showLicense} onHide={handleCloseLicense}>
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            {isEditing ? "Update Van License" : "Add Van License"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmitAddLicense)}>
            {/* image  */}
            <div className="flex-center-x-y">
              <input
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                {...register("license_photo")}
                id="icon_url"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    const allowedTypes = [
                      "image/jpeg",
                      "image/png",
                      "image/jpg",
                      "image/gif",
                      "image/svg+xml",
                    ];
                    if (allowedTypes.includes(file.type)) {
                      const imageUrl = URL.createObjectURL(file);
                      setAddLicense({
                        ...addLicense,
                        license_photo: file,
                        fileUrl: imageUrl,
                      });
                    } else {
                      toast.error(
                        "Please select a valid image file (jpeg, png, jpg, gif, svg)."
                      );
                      setAddLicense({
                        ...addLicense,
                        image: "",
                        fileUrl: "",
                      });
                    }
                  }
                }}
              />
              <label htmlFor="icon_url" className="categories_photo">
                {addLicense.fileUrl ? (
                  <img
                    className="categories-add"
                    src={addLicense.fileUrl}
                    alt="Selected"
                  />
                ) : (
                  <img src={addLicense.fileUrl || AddPhoto} alt="Category" />
                )}
                <div className="categories_cameraIcon">
                  <img src={Camera} alt="" />
                </div>
              </label>
              {errors.license_photo && (
                <p className="danger">{errors.license_photo.message}</p>
              )}
            </div>
            {/* type */}
            <div className="row">
              <div className="col-12">
                <FormControl className="w-100 mb-4" variant="outlined">
                  <InputLabel id="type-label">Type</InputLabel>
                  <Select
                    labelId="type-label"
                    label="Type"
                    {...register("license_type_id")}
                    value={addLicense.license_type_id}
                    onChange={(e) => {
                      setAddLicense({
                        ...addLicense,
                        license_type_id: e.target.value,
                      });
                    }}
                  >
                    {licenseTypes.map((lice) => (
                      <MenuItem className="custom-menu-item" value={lice.id}>
                        {lice.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errors.license_type_id && (
                  <p className="danger">{errors.license_type_id.message}</p>
                )}
              </div>
            </div>
            {/* license number  & status */}
            <div className="row">
              {/* number  */}
              <div className="col-6">
                <TextField
                  className="w-100 mb-4"
                  label="License Number"
                  variant="outlined"
                  {...register("license_number")}
                  value={addLicense.license_number}
                  onChange={(e) => {
                    setAddLicense({
                      ...addLicense,
                      license_number: e.target.value,
                    });
                  }}
                />
                {errors.license_number && (
                  <p className="danger">{errors.license_number.message}</p>
                )}
              </div>
              {/* status  */}
              <div className="col-6">
                <FormControl className="w-100 mb-4" variant="outlined">
                  <InputLabel id="type-label">Status</InputLabel>
                  <Select
                    labelId="type-label"
                    label="Status"
                    {...register("status")}
                    value={addLicense.status}
                    onChange={(e) => {
                      setAddLicense({
                        ...addLicense,
                        status: e.target.value,
                      });
                    }}
                  >
                    {licenseStatuses.map((status) => (
                      <MenuItem
                        className="custom-menu-item"
                        value={status.value}
                      >
                        {status.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errors.status && (
                  <p className="danger">{errors.status.message}</p>
                )}
              </div>
            </div>
            {/* renewal & expired date */}
            <div className="row">
              {/* renewal */}
              <div className="col-6">
                <label htmlFor="" className=" mb-1 text-muted">
                  Renewal Date
                </label>
                <TextField
                  className="w-100 mb-4"
                  type="date"
                  {...register("renewal_date")}
                  value={addLicense.renewal_date}
                  onChange={(e) => {
                    setAddLicense({
                      ...addLicense,
                      renewal_date: e.target.value,
                    });
                  }}
                />
                {errors.renewal_date && (
                  <p className="danger">{errors.renewal_date.message}</p>
                )}
              </div>
              {/* expired */}
              <div className="col-6">
                <label htmlFor="" className=" mb-1 text-muted">
                  Expired Date
                </label>
                <TextField
                  className="w-100 mb-4"
                  type="date"
                  {...register("expired_date")}
                  value={addLicense.expired_date}
                  onChange={(e) => {
                    setAddLicense({
                      ...addLicense,
                      expired_date: e.target.value,
                    });
                  }}
                />
                {errors.expired_date && (
                  <p className="danger">{errors.expired_date.message}</p>
                )}
              </div>
            </div>
            {/* footer  */}
            <div className="categories_foterAddModel">
              <button
                type="button"
                className="categories_closAddModal"
                onClick={handleCloseLicense}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="categories_saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/* insurance modal */}
      <Modal show={showInsurance} onHide={handleCloseInsurance}>
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            {isInsuranceEditing ? "Update Van Insurance" : "Add Van Insurance"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmitAddInsurance)}>
            {/* type */}
            <div className="row">
              <div className="col-12">
                <FormControl className="w-100 mb-4" variant="outlined">
                  <InputLabel id="type-label">Type</InputLabel>
                  <Select
                    labelId="type-label"
                    label="Type"
                    {...register("type_id")}
                    value={addInsurance.type_id}
                    onChange={(e) => {
                      setAddInsurance({
                        ...addInsurance,
                        type_id: e.target.value,
                      });
                    }}
                  >
                    {insuranceTypes.map((inc) => (
                      <MenuItem className="custom-menu-item" value={inc.id}>
                        {inc.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errors.type_id && (
                  <p className="danger">{errors.type_id.message}</p>
                )}
              </div>
            </div>
            {/* provider & amount */}
            <div className="row">
              {/* provider  */}
              <div className="col-6">
                <TextField
                  className="w-100 mb-4"
                  label="Provider"
                  variant="outlined"
                  {...register("provider")}
                  value={addInsurance.provider}
                  onChange={(e) => {
                    setAddInsurance({
                      ...addInsurance,
                      provider: e.target.value,
                    });
                  }}
                />
                {errors.provider && (
                  <p className="danger">{errors.provider.message}</p>
                )}
              </div>
              {/* amount  */}
              <div className="col-6">
                <TextField
                  className="w-100 mb-4"
                  label="Amount"
                  type="number"
                  variant="outlined"
                  {...register("amount")}
                  value={addInsurance.amount}
                  onChange={(e) => {
                    setAddInsurance({
                      ...addInsurance,
                      amount: e.target.value,
                    });
                  }}
                />
                {errors.amount && (
                  <p className="danger">{errors.amount.message}</p>
                )}
              </div>
            </div>
            {/* policy & date */}
            <div className="row">
              {/* policy  */}
              <div className="col-6">
                <TextField
                  className="w-100 mb-4"
                  label="Policy Number"
                  variant="outlined"
                  {...register("policy_number")}
                  value={addInsurance.policy_number}
                  onChange={(e) => {
                    setAddInsurance({
                      ...addInsurance,
                      policy_number: e.target.value,
                    });
                  }}
                />
                {errors.policy_number && (
                  <p className="danger">{errors.policy_number.message}</p>
                )}
              </div>
              {/* date  */}
              <div className="col-6">
                <TextField
                  className="w-100 mb-4"
                  type="date"
                  {...register("expiry_date")}
                  value={addInsurance.expiry_date}
                  onChange={(e) => {
                    setAddInsurance({
                      ...addInsurance,
                      expiry_date: e.target.value,
                    });
                  }}
                />
                {errors.expiry_date && (
                  <p className="danger">{errors.expiry_date.message}</p>
                )}
              </div>
            </div>
            {/* footer  */}
            <div className="categories_foterAddModel">
              <button
                type="button"
                className="categories_closAddModal"
                onClick={handleCloseInsurance}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="categories_saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/* inspection modal */}
      <Modal show={showInspection} onHide={handleCloseInspection}>
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            {isInspectionEditing
              ? "Update Van Inspection"
              : "Add Van Inspection"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmitAddInspection)}>
            {/* type */}
            <div className="row">
              <div className="col-12">
                <FormControl className="w-100 mb-4" variant="outlined">
                  <InputLabel id="type-label">Type</InputLabel>
                  <Select
                    labelId="type-label"
                    label="Type"
                    {...register("type_id")}
                    value={addInspection.type_id}
                    onChange={(e) => {
                      setAddInspection({
                        ...addInspection,
                        type_id: e.target.value,
                      });
                    }}
                  >
                    {inspectionTypes.map((insp) => (
                      <MenuItem className="custom-menu-item" value={insp.id}>
                        {insp.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errors.type_id && (
                  <p className="danger">{errors.type_id.message}</p>
                )}
              </div>
            </div>
            {/* name & status */}
            <div className="row">
              {/* name  */}
              <div className="col-6">
                <TextField
                  className="w-100 mb-4"
                  label="Inspector Name"
                  variant="outlined"
                  {...register("inspector_name")}
                  value={addInspection.inspector_name}
                  onChange={(e) => {
                    setAddInspection({
                      ...addInspection,
                      inspector_name: e.target.value,
                    });
                  }}
                />
                {errors.inspector_name && (
                  <p className="danger">{errors.inspector_name.message}</p>
                )}
              </div>
              {/* status  */}
              <div className="col-6">
                <FormControl className="w-100 mb-4" variant="outlined">
                  <InputLabel id="status-label">Status</InputLabel>
                  <Select
                    labelId="status-label"
                    label="Status"
                    {...register("status")}
                    value={addInspection.status}
                    onChange={(e) => {
                      setAddInspection({
                        ...addInspection,
                        status: e.target.value,
                      });
                    }}
                  >
                    {inspectionStatuses.map((status) => (
                      <MenuItem
                        className="custom-menu-item"
                        value={status.value}
                      >
                        {status.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errors.status && (
                  <p className="danger">{errors.status.message}</p>
                )}
              </div>
            </div>
            {/* inspection & last date */}
            <div className="row">
              {/* inspection */}
              <div className="col-6">
                <label htmlFor="" className=" mb-1 text-muted label-size">
                  Inspection Date
                </label>
                <TextField
                  className="w-100 mb-4"
                  type="date"
                  {...register("inspection_date")}
                  value={addInspection.inspection_date}
                  onChange={(e) => {
                    setAddInspection({
                      ...addInspection,
                      inspection_date: e.target.value,
                    });
                  }}
                />
                {errors.inspection_date && (
                  <p className="danger">{errors.inspection_date.message}</p>
                )}
              </div>
              {/* last_inspection_date */}
              <div className="col-6">
                <label htmlFor="" className=" mb-1 text-muted label-size">
                  Last Inspection Date
                </label>
                <TextField
                  className="w-100 mb-4"
                  type="date"
                  {...register("last_inspection_date")}
                  value={addInspection.last_inspection_date}
                  onChange={(e) => {
                    setAddInspection({
                      ...addInspection,
                      last_inspection_date: e.target.value,
                    });
                  }}
                />
                {errors.last_inspection_date && (
                  <p className="danger">
                    {errors.last_inspection_date.message}
                  </p>
                )}
              </div>
            </div>
            {/* footer  */}
            <div className="categories_foterAddModel">
              <button
                type="button"
                className="categories_closAddModal"
                onClick={handleCloseInspection}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="categories_saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/* head & data */}
      <div className="border border-1 rounded-2 p-3 my-3">
        {/* license head  */}
        <div className=" d-flex justify-content-between align-items-center border-bottom border-bottom-1 pb-4 btn-license-responsive">
          <p className=" my-0 fs-4 fw-semibold">Van License</p>
          <div className="btn-license-responsive">
            <button
              className="btn border border-1 rounded-1 mx-2"
              onClick={() => handleShowLicense()}
            >
              <Plus size={16} /> Add License
            </button>
            <button
              className="btn border border-1 rounded-1 mx-2"
              onClick={() => handleShowInsurance()}
            >
              <Plus size={16} /> Add Insurance
            </button>
            <button
              className="btn border border-1 rounded-1 ms-2"
              onClick={() => handleShowInspection()}
            >
              <Plus size={16} /> Add Inspection
            </button>
          </div>
        </div>
        {/* license data */}
        <div className="py-3">
          {!licenseData?.length &&
          !insuranceData?.length &&
          !inspectionData?.length ? (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ minHeight: "300px" }}
            >
              <NotFound
                paragraphText={
                  "No Licenses yet. All your Licenses will appear here once you get started."
                }
              />
            </div>
          ) : (
            <>
              {/* license details */}
              {licenseData && licenseData.length > 0 && (
                <div>
                  <div className=" d-flex justify-content-between align-items-center mb-2 custom-card-sm">
                    <p className="my-0 fs-5 fw-semibold">License Details :</p>
                    <div
                      onClick={() => handleEditLicense(licenseData[0])}
                      className="border border-1 rounded-3 px-3 py-1 text-secondary cursor"
                    >
                      <Edit className="small" />
                    </div>
                  </div>
                  {/* line 1 */}
                  <div className=" d-flex justify-content-between align-items-center custom-card-sm  ">
                    <div className=" d-flex align-items-center custom-card-sm ">
                      <p className=" text-muted">License Number :</p>
                      <p className=" fw-semibold mx-2">
                        {licenseData[0]?.license_number}
                      </p>
                    </div>
                    <div className=" d-flex align-items-center justify-content-start custom-card-sm ">
                      <p className=" text-muted">License Type :</p>
                      <p className=" fw-semibold mx-2">
                        {licenseData[0]?.type?.name}
                      </p>
                    </div>
                  </div>
                  {/* line 2 */}
                  <div className=" d-flex justify-content-between align-items-center custom-card-sm">
                    <div className=" d-flex align-items-center custom-card-sm">
                      <p className=" text-muted">Renewal Date :</p>
                      <p className=" fw-semibold mx-2">
                        {licenseData[0]?.renewal_date}
                      </p>
                    </div>
                    <div className=" d-flex align-items-center justify-content-start custom-card-sm">
                      <p className=" text-muted">Expiration Date :</p>
                      <p className=" fw-semibold mx-2">
                        {licenseData[0]?.expired_date}
                      </p>
                    </div>
                  </div>
                  {/* line 3 */}
                  <div className=" d-flex justify-content-between align-items-center custom-card-sm">
                    <div className=" d-flex align-items-center custom-card-sm">
                      <p className=" text-muted">License Status :</p>
                      <p className=" fw-semibold mx-2">
                        {licenseData[0]?.status}
                      </p>
                    </div>
                  </div>
                  {/* attachments */}
                  <div>
                    <p className="text-muted">Attachments :</p>
                    <div className="row g-4">
                      <div className="col-12 col-md-4">
                        <div
                          className="border border-1 d-flex justify-content-center align-items-center rounded p-2"
                          style={{ minHeight: "175px" }}
                        >
                          <img
                            src={
                              licenseData[0]?.license_photo_path
                                ? `https://estbn.com/EstbnNew/public${licenseData[0]?.license_photo_path}`
                                : AddPhoto
                            }
                            style={{
                              width: "50%",
                              objectFit: "cover",
                            }}
                            alt="Profile"
                            className="rounded"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* insurance details */}
              {insuranceData && insuranceData.length > 0 && (
                <div className="mt-3">
                  <div className=" d-flex justify-content-between align-items-center custom-card-sm mb-2">
                    <p className="my-0 fs-5 fw-semibold">Insurance Details :</p>
                    <div
                      onClick={() => handleEditInsurance(insuranceData[0])}
                      className="border border-1 rounded-3 px-3 py-1 text-secondary cursor"
                    >
                      <Edit className="small" />
                    </div>
                  </div>
                  {/* line 1 */}
                  <div className=" d-flex justify-content-between align-items-center custom-card-sm">
                    <div className=" d-flex align-items-center custom-card-sm">
                      <p className=" text-muted">Insurance Provider :</p>
                      <p className=" fw-semibold mx-2">
                        {insuranceData[0]?.provider}
                      </p>
                    </div>
                    <div className=" d-flex align-items-center justify-content-start custom-card-sm">
                      <p className=" text-muted">Insurance Policy Number :</p>
                      <p className=" fw-semibold mx-2">
                        {insuranceData[0]?.policy_number}
                      </p>
                    </div>
                  </div>
                  {/* line 2 */}
                  <div className=" d-flex justify-content-between align-items-center custom-card-sm">
                    <div className=" d-flex align-items-center custom-card-sm">
                      <p className=" text-muted">Insurance Expiry Date :</p>
                      <p className=" fw-semibold mx-2">
                        {insuranceData[0]?.expiry_date}
                      </p>
                    </div>
                    <div className=" d-flex align-items-center justify-content-start custom-card-sm">
                      <p className=" text-muted">Type of Insurance :</p>
                      <p className=" fw-semibold mx-2">
                        {insuranceData[0]?.type?.name}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              {/* insurance details */}
              {inspectionData && inspectionData.length > 0 && (
                <div className="mt-3">
                  <div className=" d-flex justify-content-between align-items-center custom-card-sm mb-2">
                    <p className="my-0 fs-5 fw-semibold">
                      Inspection Details :
                    </p>
                    <div
                      onClick={() => handleEditInspection(inspectionData[0])}
                      className="border border-1 rounded-3 px-3 py-1 text-secondary cursor"
                    >
                      <Edit className="small" />
                    </div>
                  </div>
                  {/* line 1 */}
                  <div className=" d-flex justify-content-between align-items-center custom-card-sm">
                    <div className=" d-flex align-items-center custom-card-sm">
                      <p className=" text-muted">Inspection Type :</p>
                      <p className=" fw-semibold mx-2">
                        {inspectionData[0]?.type?.name}
                      </p>
                    </div>
                    <div className=" d-flex align-items-center justify-content-start custom-card-sm">
                      <p className=" text-muted">Inspector Name :</p>
                      <p className=" fw-semibold mx-2">
                        {inspectionData[0]?.inspector_name}
                      </p>
                    </div>
                  </div>
                  {/* line 2 */}
                  <div className=" d-flex justify-content-between align-items-center custom-card-sm">
                    <div className=" d-flex align-items-center custom-card-sm">
                      <p className=" text-muted">Inspection Status :</p>
                      <p className=" fw-semibold mx-2">
                        {inspectionData[0]?.status}
                      </p>
                    </div>
                    <div className=" d-flex align-items-center justify-content-start custom-card-sm">
                      <p className=" text-muted">Last Inspection Date :</p>
                      <p className=" fw-semibold mx-2">
                        {inspectionData[0]?.last_inspection_date
                          ? dayjs(
                              inspectionData[0].last_inspection_date
                            ).format("DD MMM YYYY")
                          : ""}
                      </p>
                    </div>
                  </div>
                  {/* line 3 */}
                  <div className=" d-flex align-items-center custom-card-sm">
                    <p className=" text-muted">Inspection Date :</p>
                    <p className=" fw-semibold mx-2">
                      {inspectionData[0]?.inspection_date
                        ? dayjs(inspectionData[0].inspection_date).format(
                            "DD MMM YYYY"
                          )
                        : ""}
                    </p>
                  </div>
                  {/* line 4 */}
                  <div className=" d-flex align-items-center custom-card-sm">
                    <p className=" text-muted">Inspection Notes :</p>
                    <p className=" fw-semibold mx-2">
                      {inspectionData[0]?.notes === null
                        ? "Undefined"
                        : inspectionData[0]?.notes}
                    </p>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default License;
